$(function() {
	if (!$body.hasClass('page-template-page-listing'))
		return;

	$('.call_to_action').mouseenter(function(){
		$(this).parent().parent().addClass('white');
	}).mouseleave(function(){
		$(this).parent().parent().removeClass('white');
	});

	var sliders = $('.listing_page .slides');
	var loadedCount = 0;
	var rows = $('.listing_row');

	sliders.each(function() {
		initializeSlick(this, {
			accessibility: true,
			dots: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			arrows: true,
			fade: true,
			nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
			prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
			focusOnSelect: true,
		}, function() {
			loadedCount += 1;
			if (loadedCount == sliders.length) {
				slidersBuilt();
			}
		});
	});


	function slidersBuilt() {
		$window.trigger('resize');

		rows.each(function(i) {
			if (i%2 == 0 || i == 0) {
				$(this).addClass('even');
			} else {
				$(this).addClass('odd');
			}
		});

		setInterval(function() {
			$window.trigger('resize');
		}, 500);
	}

	$(window).on('panelsLoaded', function() {
		rows.addClass('appear');
	});

	rows.find('.button').click(function(e) {
		e.stopPropagation();
	});

});